// src/components/screener/GuestLockRow.jsx
// Extracted from ScreenerPage.jsx (SCREENER-FRAG) — content unchanged, location only.

import React from 'react';
import { S } from '../../constants/screenerConfig';

// ── Guest lock row ────────────────────────────────────────────
export default function GuestLockRow({ onRequestInvite, colCount }) {
  return (
    <tr>
      <td colSpan={colCount} style={{ padding: '28px 16px', textAlign: 'center', background: S.surface, borderTop: `1px solid ${S.border}` }}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 12 }}>
          <div style={{ fontSize: 24 }}>🔒</div>
          <div style={{ fontSize: 15, color: S.text, fontWeight: 700 }}>
            Members see all signals
          </div>
          <div style={{ fontSize: 13, color: S.muted, maxWidth: 340, lineHeight: 1.6 }}>
            Save scans, set alerts, and get smarter signals the more you use it.
          </div>
          <button
            onClick={onRequestInvite}
            style={{
              padding: '10px 28px', borderRadius: 8, border: 'none', cursor: 'pointer',
              background: 'linear-gradient(135deg, #6366f1, #8b5cf6)',
              color: '#fff', fontWeight: 700, fontSize: 14, fontFamily: 'inherit',
            }}
          >
            Request Invite → See All Results
          </button>
        </div>
      </td>
    </tr>
  );
}
